import React from 'react';
import { EXTERNAL_POPUP_WINDOW_TYPE } from '../../../redux/actions/rootAction';
import { gae } from '../../helpers/Analytics';

let nextPopupId = 1;

/** Compact label for EXTERNAL_POPUP gae events (id|ref|closed|openMs|…). */
export function popupDiagLabel(win, extra) {
  let id = '?';
  let openMs = '?';
  try {
    id = win?.__paperflyPopupId != null ? String(win.__paperflyPopupId) : 'na';
    openMs =
      win?.__paperflyPopupOpenedAt != null
        ? String(Date.now() - win.__paperflyPopupOpenedAt)
        : 'na';
  } catch (e) {
    id = 'cross_origin';
    openMs = 'na';
  }
  const hasRef = win ? '1' : '0';
  let closed = '?';
  try {
    closed = !win ? 'na' : win.closed ? '1' : '0';
  } catch (e) {
    closed = 'err';
  }
  const base = `id=${id}|ref=${hasRef}|closed=${closed}|openMs=${openMs}`;
  return extra ? `${base}|${extra}` : base;
}

export function redirectExternalPopUp(winReference, url, purpose) {
  if (!winReference) {
    gae(
      'EXTERNAL_POPUP',
      'REDIRECT_SKIP',
      `reason=no_reference|purpose=${purpose || ''}`
    );
    return;
  }
  let closed = false;
  try {
    closed = winReference.closed;
  } catch (e) {
    closed = true;
  }
  if (closed) {
    gae(
      'EXTERNAL_POPUP',
      'REDIRECT_SKIP',
      popupDiagLabel(
        winReference,
        `reason=already_closed|purpose=${purpose || ''}`
      )
    );
    return;
  }
  let host = '';
  try {
    host = url ? new URL(url, window.location.origin).host : '';
  } catch (e) {
    host = 'bad_url';
  }
  gae(
    'EXTERNAL_POPUP',
    'REDIRECT',
    popupDiagLabel(winReference, `purpose=${purpose || ''}|host=${host}`)
  );
  winReference.location = url;
  try {
    winReference.focus();
  } catch (e) {
    // Cross-origin or closed window — ignore
  }
}

export function openSignMePopupWin() {
  return {
    winType: EXTERNAL_POPUP_WINDOW_TYPE.SIGNME,
    winReference: createSignMePopupWin(),
    popupFailMessage: 'signme_settings_nopopup_message'
  };
}

export function openYesPopupWin() {
  return {
    winType: EXTERNAL_POPUP_WINDOW_TYPE.YES,
    winReference: createYesPopupWin(),
    popupFailMessage: 'yes_settings_nopopup_message'
  };
}

export function openAtrustPopupWin() {
  return {
    winType: EXTERNAL_POPUP_WINDOW_TYPE.ATRUST,
    winReference: createAtrustPopupWin(),
    popupFailMessage: 'atrust_settings_nopopup_message'
  };
}

export function createSignMePopupWin() {
  return createExternalPopupWin('/loading.html', 'Signme');
}

export function createYesPopupWin() {
  return createExternalPopupWin('/loading.html', 'Yes');
}

export function createAtrustPopupWin() {
  return createExternalPopupWin('/loading.html', 'Atrust');
}

export function createExternalPopupWin(
  pageURL,
  name = '',
  popupWinWidth = 900,
  popupWinHeight = 800
) {
  // eslint-disable-next-line no-restricted-globals
  const left = (screen.width - popupWinWidth) / 2;
  // eslint-disable-next-line no-restricted-globals
  const top = (screen.height - popupWinHeight) / 4;

  const win = window.open(
    pageURL,
    name,
    'resizable=yes,  toolbar=no, width=' +
      popupWinWidth +
      ', height=' +
      popupWinHeight +
      ', top=' +
      top +
      ', left=' +
      left
  );

  const popupId = nextPopupId++;
  if (win) {
    try {
      win.__paperflyPopupId = popupId;
      win.__paperflyPopupOpenedAt = Date.now();
    } catch (e) {
      // ignore — may be cross-origin if name reused an existing foreign window
    }
  }
  gae(
    'EXTERNAL_POPUP',
    'WINDOW_OPEN',
    popupDiagLabel(win, `name=${name}|url=${pageURL}|idAssigned=${popupId}`)
  );
  return win;
}

export function SignmeHtmlForm(formId, url, iid, vkey, skey) {
  return (
    <form action={url} id={formId} method="post" target={'Signme'}>
      <input type="hidden" name="VKEY" value={vkey} />
      <input type="hidden" name="iid" value={iid} />
      <input type="hidden" name="SKEY" value={skey} />
    </form>
  );
}
